import { InfoWindow, Marker } from '@react-google-maps/api';
import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
import { getLocalisedDate, getLocalisedTime } from '../../../Library/datetime';
import "./style.css";
import { StoreContext } from '../../../Library/contexts';
import { DEVICE_HWTYPS, VEHICLE_TYPES, VEHICLE_ICON_URLS, BIKE_NORMAL_ICON, VEHICLE_TYPE_BIKE } from '../../../Library/constants';
import { getItemFromLocalStorage } from '../../../Library/helpers';

const CustomMarker = ({ vehicle, vehicleInfo = {}, onInfoWindowClose }) => {
    const markerRefs = useRef({});
    const [ showInfoBox, setShowInfoBox ] = useState(false);
    const isUser = useRef(getItemFromLocalStorage());
    const targetVehicle = vehicleInfo;
    if(!targetVehicle) return;
    var vehicleType = targetVehicle.typ || VEHICLE_TYPE_BIKE;
    const vehicleTypeName = VEHICLE_TYPES[vehicleType];
    const vehicleIcons = VEHICLE_ICON_URLS[vehicleTypeName] || VEHICLE_ICON_URLS["Two wheeler"];
    var iconUrl = vehicleIcons["NORMAL"];
    if (!targetVehicle.hwtyp || targetVehicle.hwtyp === DEVICE_HWTYPS["Wired"]) {
      if(!vehicle.mainPower){
        iconUrl = vehicleIcons["POWER_OFF"];
      } else if (!vehicle.ignition && vehicle.motion) {
        iconUrl = vehicleIcons["MOTION"];
      } else if (vehicle.ignition && vehicle.motion) {
        iconUrl = vehicleIcons["IGNITION"];
      } else iconUrl = vehicleIcons["NORMAL"];
    } else {
      if (vehicle.ignition) iconUrl = vehicleIcons["IGNITION"];
      else iconUrl = vehicleIcons["NORMAL"];
    }
  const handleMarkerLoad = (marker, vehicleId) => {
    markerRefs.current[vehicleId] = marker
  }

  function getShortestRotation(currentAngle, newAngle) {
    const delta = ((newAngle - currentAngle + 540) % 360) - 180;
    return currentAngle + delta;
  }


  if(markerRefs.current[vehicle.vid]){
    const marker = document.querySelector(`div[style*="z-index: ${vehicle.vid}"] img`);
    if(marker){
      const currentRotation = parseFloat(marker.style.transform.replace(/rotate\((.*)deg\)/, '$1')) || 0;
      const newRotation = getShortestRotation(currentRotation, vehicle.direction);

      marker.style.transition = "cubic-bezier(0.19, 1, 0.22, 1) 0.4s";
      marker.style.transform = `rotate(${newRotation}deg)`;
    }
  }

  const handleMapMarkerClick = () => {
    setShowInfoBox(true)

    if (isUser.current) {
      global.EE.emitEvent(global.EE.EVENT_TYPES.VEHICLE_INFO_SHOWN, vehicle);
    }
  }

  return (
    <>
      {vehicle.lat ?
        <Marker key={vehicle.vid} onClick={handleMapMarkerClick}
        position={{ lat: vehicle.lat, lng: vehicle.lng }}
        icon={{ url: iconUrl, scaledSize: new window.google.maps.Size(37, 58), scale: 1, anchor: { x: 16, y: 16 }}}
        onLoad={(marker) => handleMarkerLoad(marker, vehicle.vid)}
        zIndex={vehicle.vid}
      >
        {(showInfoBox && vehicleInfo) ? <InfoWindow onCloseClick={() => {setShowInfoBox(false); if (onInfoWindowClose) onInfoWindowClose()}} >
          <div className="info-box">
            <p className='veh-reg'>{ vehicleInfo.reg || "" }</p>
            <label>
              Last Seen:
              <p>{getLocalisedDate(vehicle.ts * 1000)}, {getLocalisedTime(vehicle.ts * 1000)}</p>
            </label>
            <label>
              Speed:
              <p>{vehicle.spd && vehicle.ignition ? vehicle.spd.toFixed(2) : 0} km/hr</p>
            </label>
            {vehicle.hasOwnProperty("ignition") ?
            <label>
              Ignition:
              <p>{vehicle.ignition ? "ON" : "OFF"}</p>
            </label> : null}
          </div>
        </InfoWindow> : null}
      </Marker>
       : null}
    </>
  );
}

export default CustomMarker
